<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Zone Exception</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label for="ddlZone">Zone</label>
        <select class="form-control" id="ddlZone" v-model="selected_zone_id">
          <option value="0">Select..</option>
          <option v-for="zone in zones" :key="zone.zone_id" v-bind:value="zone.zone_id">[{{ zone.site.name }}] {{ zone.name }}
          </option>
        </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-6">
        <button class="btn btn-success" @click="addZoneException()"><i class="fa fa-edit" aria-hidden="true"></i>
          Add Zone Exception</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="zone_exception in zone_exceptions" :key="zone_exception.zone_exception_id">
            <td>{{ zone_exception.zone.name }}</td>
            <td>
              <button type="button" class="btn btn-outline-danger" @click="deleteZoneException(zone_exception)"><i
                class="fa fa-trash fa-fw" aria-hidden="true"></i>Delete</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      selected_zone_id: '0'
    }
  },
  computed: mapGetters({
    zones: 'allZones',
    zone_exceptions: 'allZoneExceptions'
  }),
  created () {
    this.$store.dispatch('getZones')
    this.$store.dispatch('getZoneExceptions')
  },
  methods: {
    ...mapActions([
      'deleteZoneException'
    ]),
    addZoneException () {
      if (this.selected_zone_id !== '0') {
        this.$store.dispatch('addZoneException', this.selected_zone_id)
      } else {
        alert('Select a zone.')
      }
    }
  }
}
</script>
